import { adalApiFetch } from "authProvider";
import { endPoints, API_ROOT_V2 } from "appSettings";
import { UserFormData } from "./type";

export const getUserV2 = (emailAddress: string) => {
  return (dispatch: any) => {
    return adalApiFetch(
      fetch,
      `${API_ROOT_V2}${endPoints.user}/${emailAddress}`,
      {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      },
      dispatch
    ).then((response: any) => response.json());
  };
};

export const createUserV2 = (data: UserFormData) => {
  return (dispatch: any) => {
    return adalApiFetch(
      fetch,
      `${API_ROOT_V2}${endPoints.user}`,
      {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify(data),
      },
      dispatch
    ).then((response: any) => {
      if (!response.ok) {
        return Promise.reject(response.json());
      }
      response.json();
    });
  };
};
